import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { formatMoney } from "@bw/shared/utils";
import type { ModuleReceiptDetailProps } from "./companyReceiptContracts";
import { invoiceEvidenceLabel } from "./companyPaymentLabels";

export function ModuleReceiptDetail({ receipt, onClose }: ModuleReceiptDetailProps) {
  return <Stack spacing={1} aria-label="Recorded company receipt" sx={{ borderTop: 1, borderColor: "divider", pt: 2 }}>
    <Typography variant="h6" component="h3">Recorded charge: {formatMoney(receipt.collected_amount.amount_minor / 100, receipt.collected_amount.currency)}</Typography>
    <Typography variant="body2" color="text.secondary">Recorded {new Date(receipt.recorded_at).toLocaleString()}</Typography>
    {receipt.merchant_name !== null ? <Typography>{receipt.merchant_name}</Typography> : null}
    {receipt.purpose !== null ? <Typography>{receipt.purpose}</Typography> : null}
    <Typography>{invoiceEvidenceLabel[receipt.invoice_state]}</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>Confirmation number: {receipt.confirmation_number}</Typography>
    <Button size="small" sx={{ alignSelf: "flex-start" }} onClick={onClose}>Close receipt</Button>
  </Stack>;
}
